"use client";

import { Instagram, Youtube, Twitter } from "lucide-react";
import { Link } from "@/components/common/Link";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
import { WvcLogo } from "@/integrations/wordpress/WvcLogo";
function FooterNavConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <ul className="space-y-3">
        <li className="h-4 w-24 bg-muted animate-pulse rounded-md" />
        <li className="h-4 w-20 bg-muted animate-pulse rounded-md" />
        <li className="h-4 w-28 bg-muted animate-pulse rounded-md" />
        <li className="h-4 w-16 bg-muted animate-pulse rounded-md" />
      </ul>;
  }
  return <ul className="space-y-3">
      {menuItems.map((item, i) => <li data-index={i} key={item.id}>
          <Link to={item.href || "#"} className="text-foreground text-[15px] hover:text-primary transition-colors duration-200 font-default">
            {item.label}
          </Link>
        </li>)}
    </ul>;
}
const capabilities = [{
  label: "Our Philosophy",
  href: "/PhilosophyPage"
}, {
  label: "Our Program",
  href: "/OurProgramPage"
}, {
  label: "Sample Schedule",
  href: "/OurProgramPage"
}, {
  label: "Lunch & Snacks",
  href: "/OurProgramPage"
}, {
  label: "Fees & Enrollment",
  href: "/FeesEnrollmentPage"
}, {
  label: "Registration",
  href: "/FeesEnrollmentPage"
}];
const socials = [{
  name: "Instagram",
  icon: Instagram,
  href: "#"
}, {
  name: "YouTube",
  icon: Youtube,
  href: "#"
}, {
  name: "Twitter",
  icon: Twitter,
  href: "#"
}];
export default function Footer() {
  return <section data-section-id="4966" id="school-footer" className="relative bg-background text-foreground pt-[120px] pb-12 px-6 md:px-10 lg:px-16">
      {}
      <span aria-hidden="true" className="absolute top-4 left-4 w-4 h-4 border-l border-t border-border/60" />
      <span aria-hidden="true" className="absolute top-4 right-4 w-4 h-4 border-r border-t border-border/60" />
      <span aria-hidden="true" className="absolute bottom-4 left-4 w-4 h-4 border-l border-b border-border/60" />
      <span aria-hidden="true" className="absolute bottom-4 right-4 w-4 h-4 border-r border-b border-border/60" />

      <div className="max-w-7xl mx-auto">
        {}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-12 gap-10 lg:gap-8">
          {}
          <div className="lg:col-span-5 space-y-6">
            <Link to="/" className="inline-block">
              <WvcLogo className="h-8 w-auto" />
            </Link>
            <p className="text-[14px] text-muted-foreground font-default max-w-sm leading-relaxed">
              The mighty oak from the little acorn grows. Nurturing young minds in Parkwoods-Donalda since 2005.
            </p>

            {}
            <div className="pt-4 space-y-1.5 font-mono text-[11px] text-muted-foreground uppercase tracking-wider">
              <div className="flex items-center gap-2">
                <span className="text-muted-foreground/70">EST</span>
                <span className="text-foreground/80">2005</span>
              </div>
              <div className="flex items-center gap-2">
                <span className="text-muted-foreground/70">LOC</span>
                <span className="text-foreground/80">NORTH YORK, ON</span>
              </div>
            </div>

            {}
            <div className="flex items-center gap-5 pt-2">
              {socials.map((social, i) => {
              const Icon = social.icon;
              return <Link data-index={i} key={social.name} to={social.href} aria-label={social.name} className="group text-foreground hover:text-primary transition-colors duration-200">
                    <Icon className="w-5 h-5" strokeWidth={1.5} aria-hidden="true" />
                  </Link>;
            })}
            </div>
          </div>

          {}
          <div className="lg:col-span-2">
            <h3 className="font-default font-mono text-[12px] uppercase tracking-[0.15em] text-muted-foreground mb-6">
              Navigate
            </h3>
            <MenuProvider menu_id="3">
              <FooterNavConsumer />
            </MenuProvider>
          </div>

          {}
          <div className="lg:col-span-2">
            <h3 className="font-default font-mono text-[12px] uppercase tracking-[0.15em] text-muted-foreground mb-6">
              School Info
            </h3>
            <ul className="space-y-3">
              {capabilities.map((cap, i) => <li data-index={i} key={cap.label}>
                  <Link to={cap.href} className="text-foreground text-[15px] hover:text-primary transition-colors duration-200 font-default">
                    {cap.label}
                  </Link>
                </li>)}
            </ul>
          </div>

          {}
          <div className="lg:col-span-3">
            <h3 className="font-default font-mono text-[12px] uppercase tracking-[0.15em] text-muted-foreground mb-6">
              Contact Us
            </h3>
            <div className="space-y-4">
              <p className="text-[14px] text-muted-foreground leading-relaxed font-default">
                123 Parkwoods Village Dr,
                <br />
                North York, ON M3A 2X7
              </p>
              <div className="space-y-2 font-mono text-[13px]">
                <Link to="mailto:hello@littleacorns.ca" className="block text-foreground hover:text-primary transition-colors duration-200">
                  hello@littleacorns.ca
                </Link>
                <Link to="tel:+14165550123" className="block text-foreground hover:text-primary transition-colors duration-200">
                  (416) 555-0123
                </Link>
              </div>
              <div className="pt-2 font-mono text-[11px] text-muted-foreground uppercase tracking-wider">
                <span className="text-muted-foreground/70">Hours </span>
                <span className="text-foreground/80">Mon-Fri 08:00-18:00</span>
              </div>
            </div>
          </div>
        </div>

        {}
        <div className="relative my-14">
          <div className="h-px bg-border w-full" />
          <span aria-hidden="true" className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 flex items-center justify-center">
            <span className="block w-3 h-px bg-border" />
            <span className="block w-px h-3 bg-border absolute" />
          </span>
        </div>

        {}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 items-center font-mono text-[11px] uppercase tracking-[0.12em]">
          {}
          <div className="text-muted-foreground text-center md:text-left">
            © 2024 Little Acorns Montessori · All Rights Reserved
          </div>

          {}
          <div className="flex justify-center">
            <span className="inline-flex items-center gap-2 px-3 py-1.5 border border-border text-foreground/80">
              <span className="text-muted-foreground/70">CWELCC</span>
              <span>PARTICIPANT</span>
            </span>
          </div>

          {}
          <div className="flex items-center gap-2 justify-center md:justify-end text-muted-foreground">
            <span className="w-1.5 h-1.5 rounded-lg bg-chart-3 animate-pulse" aria-hidden="true" style={{
            boxShadow: "0 0 8px var(--chart-3)"
          }} />
            <span>
              Enrollment: <span className="text-foreground/80">Open</span> ·
              Ratio <span className="text-foreground/80">1:8</span>
            </span>
          </div>
        </div>
      </div>
    </section>;
}